
export const group = '/dag-api/get-group'
export const leaderboard = '/dag-api/get-leader'
export const refreshDate = '/dag-api/get-refdate'
export const overallScores = '/dag-api/college-home'
export const stakeholdersLeaderboard = '/dag-api/get-leader/CAHS'
export const thirdPartyTable = '/dag-api/get-third-party'
export const getwebScore = '/dag-api/get-web-score'
export const getWebsites = '/dag-api/get-websites'
export const GetIssueList = '/dag-api/get-issue'
export const GetWebGraph = '/dag-api/get-graph-data'